import React from 'react';
import { IonCard, IonIcon, IonItem, IonLabel, IonGrid, IonRow, IonCol } from '@ionic/react';
import useNavigation from '../hooks/useNavigation';
import { makeCall } from '../hooks/common';
import { checkmark, personOutline, call, calendarOutline } from 'ionicons/icons';
import moment from 'moment';

interface IProps {
    user: any;
    selectedValue?: string;
    onClickHandler?: Function
}

const UserCard: React.FC<IProps> = (props) => {
    const navigateTo = useNavigation();

    return (
        <>
            <IonCard onClick={() => props.onClickHandler ? props.onClickHandler(props.user) : navigateTo('/tabs/user', { userId: props.user.farmUserId })} style={{ margin: '8px', borderRadius: '12px' }}>
                {/* Header with User Name and Selection Status */}
                <IonItem style={{ '--background': 'transparent', '--border-color': 'transparent' }}>
                    <IonLabel>
                        <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: '0' }}>
                            {props.user.name || 'Unnamed User'}
                        </h2>
                    </IonLabel>
                    {props.selectedValue === props.user.farmUserId && (
                        <IonIcon icon={checkmark} style={{ fontSize: '20px', color: '#3880ff' }} />
                    )}
                </IonItem>

                {/* Main Content Grid */}
                <IonGrid style={{ padding: '0 16px 16px 16px' }}>
                    <IonRow>
                        {/* Left Column - User Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* Mobile Number */}
                            {props.user.mobile && (
                                <div style={{ marginBottom: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <IonIcon icon={call} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                        <span 
                                            style={{ fontSize: '14px', cursor: 'pointer' }}
                                            onClick={e => { e.stopPropagation(); makeCall(e, props.user.mobile) }}
                                        >
                                            {props.user.mobile}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </IonCol>

                        {/* Right Column - Additional Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* Created Date */}
                            {props?.user?.created_date && (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <IonIcon icon={calendarOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                    <span style={{ fontSize: '12px', color: '#666' }}>
                                        {moment(props.user.created_date).fromNow()}
                                    </span>
                                </div>
                            )}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonCard>
        </>
    );
};

export default UserCard;